import { render, staticRenderFns } from "./SerumFormula.vue?vue&type=template&id=725a90c7&scoped=true&"
import script from "./SerumFormula.vue?vue&type=script&lang=js&"
export * from "./SerumFormula.vue?vue&type=script&lang=js&"
import style0 from "./SerumFormula.vue?vue&type=style&index=0&id=725a90c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725a90c7",
  null
  
)

export default component.exports